module.exports = __webpack_public_path__ + "static/media/dark-theme-total-entry.8e9ec91c.svg";